import React from 'react'

export default function Footer() {
  return (
    <div>
           {/* Footer Start */}
    <div
      className="container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-3 col-md-6">
            <h4 className="text-white mb-3">Company</h4>
            <a className="btn btn-link" href="/about">
              About Us
            </a>
            <a className="btn btn-link" href="/contact">
              Contact Us
            </a>
            <a className="btn btn-link" href="/packages">
              Packages
            </a>
            <a className="btn btn-link" href="/VisaAssistance">
              Visa Assistance
            </a>
            <a className="btn btn-link" href="/Consultancy">
              Consultancy
            </a>
          </div>
          <div className="col-lg-3 col-md-6">
            <h4 className="text-white mb-3">Offices</h4>
            <div className="mb-4">
              <h6 className="text-primary mb-2">Head Office</h6>
              <p className="mb-2 small">
                <i className="fa fa-map-marker-alt me-3" />
                Suite 813-815, 8th Floor, Park Avenue, Block 6, PECHS, Shahrah-e-Faisal, Karachi, Pakistan
              </p>
            </div>
            <div className="mb-4">
              <h6 className="text-primary mb-2">Site Office</h6>
              <p className="mb-2 small">
                <i className="fa fa-map-marker-alt me-3" />
                Office # 203, 2nd Floor, Aamir Trade Center, Shahrah-e-Qaideen, P.E.C.H.S Block 2, Karachi, Pakistan
              </p>
            </div>
            <p className="mb-2">
              <i className="fa fa-phone-alt me-3" />
              +92 300 8261 571
            </p>
            <p className="mb-2">
              <i className="fa fa-envelope me-3" />
              sales@falcondestinations.com
            </p>
            <div className="d-flex pt-2">
              <a className="btn btn-outline-light btn-social" href="https://www.facebook.com/share/17q1iTtr5q/?mibextid=wwXIfr" target='_blank'>
                <i className="fab fa-facebook-f" />
              </a>
              <a className="btn btn-outline-light btn-social" href="https://www.instagram.com/falcondestinations_?igsh=MWR4bmo4MmZ5ZDdqcw%3D%3D&utm_source=qr" target='_blank'>
                <i className="fab fa-instagram" />
              </a>
              <a className="btn btn-outline-light btn-social" href="https://www.linkedin.com/company/falcon-destinations/" target='_blank'>
                <i className="fab fa-linkedin" />
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <h4 className="text-white mb-3">Gallery</h4>
            <div className="row g-2 pt-2">
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/Singapore.jpg"
                  alt=""
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/Malaysia.jpg"
                  alt=""
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/Sri Lanka.jpg"
                  alt=""
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/Umrah.jpg"
                  alt=""
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/hajjpackage.jpg"
                  alt=""
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/Turkey.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <h4 className="text-white mb-3">Newsletter</h4>
            <p>Falcon Destinations (Pvt.) Ltd. is a holidays, travels and tours company with an aim to provide quality service to its customers worldwide.</p>
            <div
              className="position-relative mx-auto"
              style={{ maxWidth: 400 }}
            >
              <input
                className="form-control border-primary w-100 py-3 ps-4 pe-5"
                type="text"
                placeholder="Your email"
              />
              <button
                type="button"
                className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
              >
                SignUp
              </button>
            </div>
          </div>
        </div>

        {/* Global Presence Section */}
        <div className="row g-5 mt-4 pt-4 border-top">
          <div className="col-12">
            <h4 className="text-white mb-4">Global Presence</h4>
          </div>
          <div className="col-lg-3 col-md-6">
            <h6 className="text-primary mb-3">KSA Office</h6>
            <p className="small mb-2">
              <i className="fa fa-map-marker-alt me-2" />
              Abu Firas Al-Hamadani Street, District Al-Rawais, Jeddah 23214, Kingdom of Saudi Arabia.
            </p>
            <p className="small">
              <i className="fa fa-phone-alt me-2" />
              +966 599 686 962
            </p>
          </div>
          <div className="col-lg-3 col-md-6">
            <h6 className="text-primary mb-3">United States of America</h6>
            <p className="small">
              <i className="fa fa-map-marker-alt me-2" />
              3 The Green, Suite B Dover, Delaware 19901, USA
            </p>
          </div>
          <div className="col-lg-3 col-md-6">
            <h6 className="text-primary mb-3">United Kingdom</h6>
            <p className="small">
              <i className="fa fa-map-marker-alt me-2" />
              4 St. Lawrences Road Coventry CV6 7AA England & Wales United Kingdom
            </p>
          </div>
          <div className="col-lg-3 col-md-6">
            <h6 className="text-primary mb-3">Singapore</h6>
            <p className="small">
              <i className="fa fa-map-marker-alt me-2" />
              68 Circular Road, #02-01 Singapore 049422
            </p>
          </div>
          <div className="col-lg-3 col-md-6">
            <h6 className="text-primary mb-3">China</h6>
            <p className="small">
              <i className="fa fa-map-marker-alt me-2" />
              Office 1201, Building 2, BRETC Business Centre, No. 10 Wuqu Road, Dongnan Street, Changshu, Suzhou, Jiangsu Province, China
            </p>
          </div>
        </div>
      </div>
      {/* <div className="container">
        <div className="copyright">
          <div className="row">
            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
              ©{" "}
              <a className="border-bottom" href="#">
                Your Site Name
              </a>
              , All Right Reserved.
              Designed By{" "}
              <a className="border-bottom" href="https://github.com/ParasSalunke">
                Paras Salunke
              </a>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <div className="footer-menu">
                <a href="/">Home</a>
                <a href="/">Cookies</a>
                <a href="/">Help</a>
                <a href="/">FQAs</a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
    {/* Footer End */}
    </div>
  )
}
